import { InjectionToken } from '@angular/core';

export const APP_DOMAIN = new InjectionToken<string>('APP_DOMAIN');
